export default __webpack_public_path__ + "static/media/services-bg.7ee93b6b.png";